// ============================================================
// CELESTIAL STUDIOS — UNIVERSE OF STORIES
// Three realms of the archive: Films, TV Series, Books.
// Each realm holds its works behind tabs on its page.
// ============================================================

// every record burns in one light — gold
export const ACCENTS = {
  films: { main: "#f0d78a", soft: "rgba(240,215,138,0.55)", halo: "rgba(240,215,138,0.18)", name: "gold" },
  "tv-series": { main: "#f0d78a", soft: "rgba(240,215,138,0.55)", halo: "rgba(240,215,138,0.18)", name: "gold" },
  books: { main: "#f0d78a", soft: "rgba(240,215,138,0.55)", halo: "rgba(240,215,138,0.18)", name: "gold" },
};

export const PROJECTS = [
  {
    slug: "films",
    title: "Films",
    medium: "Feature Films",
    keyArt: "/assets/keyart_hermetica_keyhole.png",
    artPos: "50% 36%",
    artPosMobile: "50% 20%",
    sigil: "/assets/medallion_eye.png",
    works: [
      {
        id: "the-hermetica",
        title: "The Hermetica",
        titleImg: "/assets/title_hermetica.png",
        medium: "Feature Film",
        logline:
          "A college journalist covering the disappearance of a fellow student finds herself drawn into the strange secrets of her Occult Studies classmates.",
      },
    ],
  },
  {
    slug: "tv-series",
    title: "TV Series",
    medium: "Television",
    dim: true,
    keyArt: "/assets/keyart_ambition_still.jpg",
    sigil: "/assets/spade.png",
    works: [
      {
        id: "deadly-ambition",
        title: "Deadly Ambition",
        titleImg: "/assets/title_ambition.png",
        medium: "Television Series",
        logline:
          "A devout journalist investigates a high-profile murder and becomes entangled with the accused, a man vilified by his community yet romanticised by the public, dragging them both into a world governed by dark, unseen forces.",
        credits: {
          crew: [
            { name: "Bianca K. Nuñez", role: "Writer · Showrunner" },
            { name: "Adriana DeSimone", role: "Producer" },
            { name: "Charlotte Rinaldi", role: "Associate Producer" },
          ],
          cast: [
            { actor: "Bianca K. Nuñez", role: "Liana Castillo", lead: true },
            { actor: "Alexander Lloyd", role: "Dominic Hale", lead: true },
            { actor: "Izaak Love", role: "Cole Mancini" },
            { actor: "Camila Ponte Alvarez", role: "Sofia Castillo" },
            { actor: "Elias Jasser", role: "Julian Farid" },
            { actor: "Helen Hailu", role: "Brielle Sinclair" },
          ],
        },
      },
    ],
  },
  {
    slug: "books",
    title: "Books",
    medium: "Literature",
    keyArt: "/assets/keyart_osirica_gate.png",
    sigil: "/assets/lion_coin.png",
    works: [
      {
        id: "osirica",
        title: "Osirica",
        titleImg: "/assets/title_osirica.png",
        medium: "Literary Saga",
        logline:
          "Zafira, a brilliant scribe and reluctant noblewoman, is destined to marry Anubis, prince of the Osirica royal clan, a union blessed by divine prophecy. Meanwhile, a brutal spiritual war erupts between the Osirica, guardians of ancient knowledge, and the Ascetics, led by Anubis' uncle, who seek to erase history and impose a new god. When Zafira's village is massacred and her sister kidnapped, she and Anubis are forced together on a quest that becomes the origin story of the Osirica, laying the foundation of a society meant to unite wisdom and faith, one destined to fracture centuries later.",
      },
      {
        id: "a-college-of-wicked-minds",
        title: "A College of Wicked Minds",
        medium: "Novel Series",
        logline:
          "A College of Wicked Minds, set at Brentwood College, follows journalism major Liana Castillo and her unlikely group of Occult Studies 101 classmates who discover that their strange class makes for an even stranger detective team when they begin investigating the mysteries haunting their elite college.",
      },
    ],
  },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);
